import './css/main.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { createRoot } from 'react-dom/client';

// Initialize theme before rendering
const initializeTheme = () => {
	const savedTheme = localStorage.getItem('theme');
	const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
	const theme = savedTheme || (systemPrefersDark ? 'dark' : 'light');
	
	document.documentElement.classList.remove('light', 'dark');
	document.documentElement.classList.add(theme);
	
	// Update meta theme-color
	const metaThemeColor = document.querySelector('meta[name="theme-color"]');
	if (metaThemeColor) {
		metaThemeColor.setAttribute('content', theme === 'dark' ? '#0f1221' : '#ffffff');
	}
};

// Initialize theme immediately
initializeTheme();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

reportWebVitals();
